import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { PhoneIcon, VideosIcon } from "../../lib/icons";

import ActionButton, { ButtonElem } from "../MoreButton";
import type { GlobalState } from "../../lib/types";

const LocationCard = ({ location, small }) => {
  const { name, image_url, address, phone, url } = location;

  const cardClasses = small ? "small" : "";

  let imageElem;
  if (image_url) {
    imageElem = <div className="image" style={{ backgroundImage: `url(${image_url})` }} />;
  } else {
    imageElem = (
      <div className="image empty">
        <VideosIcon />
      </div>
    );
  }

  // If we need to use a phone number that pulls from the website.
  let phoneToUse = phone;
  if (window.FamilyAssetsChat.trackedPhone) {
    phoneToUse = window.FamilyAssetsChat.trackedPhone;
  }

  return (
    <ShadowCard className={cardClasses}>
      <a href={url} target="_blank" rel="noopener noreferrer" className="image-link">
        {imageElem}
      </a>

      <div className="card-body">
        <div className="data">
          <div className="name">{name}</div>
          <div className="address">{address}</div>
        </div>

        <Controls>
          <a href={url} target="_blank" rel="noopener noreferrer">
            <ActionButton>More Details</ActionButton>
          </a>

          <a href={`tel:${phoneToUse}`}>
            <ActionButton className="call-us">
              Call Us <PhoneIcon />
            </ActionButton>
          </a>
        </Controls>
      </div>
    </ShadowCard>
  );
};

class LocationsComponent extends React.Component {
  render() {
    const { locationsData } = this.props;

    const mainLocation = locationsData[0];
    const satelliteLocations = locationsData.slice(1);

    return (
      <>
        <LocationCard location={mainLocation} key={-1} />
        {satelliteLocations.map((location, i) => (
          <LocationCard location={location} small key={i} />
        ))}
      </>
    );
  }
}

function mapStateToProps(state: GlobalState, ownProps) {
  const { locationsData } = ownProps;
  return {
    locationsData,
  };
}

const Controls = styled.div`
  border-top: 1px solid #f0f0f0;
  padding: 11px 13px 14px 20px;
  display: flex;
  justify-content: space-between;
`;

const ShadowCard = styled.div`
  box-shadow: 0 2px 9px rgba(217, 217, 217, 0.5);
  border-radius: 11px;
  margin-bottom: 10px;

  .image {
    background-size: 100%;
    background-position: center center;
    height: 123px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;

    &.empty {
      background-color: #d3d3d378;
      display: flex;
      justify-content: center;
      align-items: center;

      svg {
        width: 80%;
        height: 80%;
      }
    }
  }

  .data {
    padding: 16px 20px;
  }

  .name {
    color: #312f4c;
    font-weight: 800;
    font-size: 16px;
    line-height: 22px;
  }

  .address {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: #000000;
  }

  &.small {
    display: flex;
    flex-direction: row;

    .image-link {
      width: 102px;

      .image {
        background-size: unset;
        border-top-right-radius: unset;
        border-bottom-left-radius: 6px;
        height: 100%;
      }
    }

    .data {
      padding: 8px 13px 12px 11px;
    }

    ${Controls} {
      padding: 10px 13px 10px 11px;
    }

    ${ButtonElem} {
      padding: 8px 9px;

      &.call-us {
        padding: 6px 9px;
      }
    }
  }
`;

export default connect(mapStateToProps)(LocationsComponent);
